import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// import TrendingNewsContext from "../../contexts/HomeOne/TrendingNewsContext";
// import dateFormat from "../../lib/dateFormat";
import logo from "../../assets/images/News/uk-express.png";
import { TrendingnewsData } from "../../Services/service";
import ShareButton from "../../components/ShareButton/ShareButton";


function TrendingNews() {
  const [category,setCategory] = useState("All");
  const [newsData, setNewsData] = useState({})
  
  useEffect(() => {
    loadData();
  }, []);

  async function loadData() {
    const Tdata = await TrendingnewsData();
    setNewsData(Tdata); 
  }
  // console.log( "newsData",newsData )
  // console.log( "category",category )
  // console.log( "newsData[category]",newsData[category] )
  // console.log("Is Array:", Array.isArray(newsData[category]));
  return (
    <>
      <div className="binduz-er-trending-news-topbar d-block d-md-flex justify-content-between align-items-center">
          <div className="binduz-er-trending-box">
            <div className="binduz-er-title">
              <h3 className="binduz-er-title">Trending News</h3>
            </div>
          </div>
          <div className="binduz-er-news-tab-btn d-flex justify-content-md-end justify-content-start">
            <ul className="nav nav-pills" id="pills-tab" role="tablist">
              {Object.keys(newsData).map((item, index) => (
                <li key={index} className="nav-item" role="presentation">
                  <a
                    className={`nav-link ${category === item ? "active" : ""}`}
                    onClick={() => setCategory(item)}
                    href="#"
                    role="tab"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>
      </div>             
                    <div className="col-lg-5 col-md-6">
                      <div className="binduz-er-trending-news-list-item">
                      {Array.isArray(newsData[category]) ?(
              newsData[category].map((newsItem, index) => (
                          <div key={index} className="binduz-er-trending-news-list-box">
                            <div className="binduz-er-thumb">
                              <Link to={`/News/${newsItem.id}`}><img src={newsItem?.images?.[0] || logo} alt="" /></Link>
                            </div>
                            <div className="binduz-er-content">
                              <div className="binduz-er-meta-item">
                                <div className="binduz-er-meta-categories">
                                  <a href="#">{newsItem?.news}</a>
                                </div>
                                <div className="binduz-er-meta-date">
                                  <span>
                                    <i className="fal fa-calendar-alt"></i>
                                    {newsItem?.date}
                                  </span>
                                </div>
                                <div className="share">
                                  <ShareButton open={`${newsItem.id}`}/>
                                </div>
                              </div>
                              <div className="binduz-er-trending-news-list-title">
                                <h4 className="binduz-er-title line-clump-2">
                                  <Link to={`/News/${newsItem.id || index+1}`}>{newsItem?.title}</Link>
                                </h4>
                              </div>
                            </div>
                          </div>
                          )
                        )
                      ):(<h1>Category Not Found</h1>)}
                        
                      </div>
                    </div>
 </>
  )
}
export default TrendingNews
